<template>
  <div>
    <auth-modal v-if="!emailSent" :backLinkText="backLinkText" backlink="login">
      <template v-slot:title>
        <h1>{{ $t("auth-form-recover-title") }}</h1>
      </template>
      <template v-slot:content>
        <p>{{ $t("auth-form-recover-description") }}</p>
      </template>
      <template v-slot:footer-content>
        <form>
          <fieldset>
            <input
              type="email"
              name="email"
              v-model.trim="email"
              :placeholder="$t('auth-login-form-email-placeholder')"
            />
            <div class="form-group flex">
              <button
                type="submit"
                class="primary"
                @click.prevent="recover"
                :disabled="!email || !emailIsValid"
              >
                {{ $t("auth-form-recover") }}
                <plane-icon width="14" height="14"></plane-icon>
              </button>
            </div>
          </fieldset>
        </form>
      </template>
    </auth-modal>
    <auth-modal v-else backlink="login" :btntext="btntext">
      <template v-slot:title>
        <h1>{{ $t("email-sent") }}</h1>
      </template>
      <template v-slot:content>
        <p>{{ $t("recover-email-content") }}</p>
      </template>
    </auth-modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Base from "@/views/modules/base/Index";
import AuthModal from "@/components/AuthModal";
import PlaneIcon from "@/components/icons/PlaneIcon";

export default {
  name: "ResetPassword",
  extends: Base,
  components: {
    AuthModal,
    PlaneIcon
  },
  data() {
    return {
      email: "",
      emailSent: false
    };
  },
  computed: {
    backLinkText() {
      return this.$t("auth-verification-modal-back");
    },
    btntext() {
      return this.$t("auth-back-to-login");
    },
    emailIsValid() {
      const regex = /^(.+@.+)$/;
      return regex.test(this.email);
    }
  },
  methods: {
    ...mapActions("common", ["setLoading", "showModal"]),
    recover() {
      if (!this.email.length) return;
      this.setLoading(true);
      this.$store
        .dispatch("auth/recover", this.email)
        // TODO show Email sent confirmation
        .then(res => {
          if (res && res.status === 200) {
            this.emailSent = true;
          }
          this.setLoading(false);
        })
        .catch(err => {
          this.setLoading(false);
          this.emailSent = false;
          this.showModal({
            title: err.errorCode
          });
          this.resetForm();
        });
    },
    resetForm() {
      this.email = "";
    }
  }
};
</script>

<style lang="scss" scoped>
form {
  width: 100%;
  .form-group {
    justify-content: flex-end;
  }
  button {
    svg {
      margin-right: 0;
      margin-left: 5px;
    }
  }
}
</style>
